import 'bootstrap/dist/css/bootstrap.min.css';

export default function RehearsalLocationMapInfo () {

    return (
        <>
            <div className= 'rehearsalInfoContainer flex object-contain w-auto h-5/12 pt-11 mx-10 gap-8 align-baseline justify-between'>
                <div className='text-left'>
                    <p className='mb-2 underline'> Rehearsal Info:</p>
                    <p className='mb-0.5'> Follen Church</p>
                    <p className='mb-0.5'> 755 Massachusetts Ave</p> 
                    <p className='mb-3'>Lexington, MA 02420</p>
                    <p className='0.5'>1st and 3rd Wednesdays of the month</p>
                </div>
                <div className = 'googleFrameContain'>
                    <iframe title ="RehearsalMap" className = 'googleFrame' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5889.806843129683!2d-71.20957172335312!3d42.42979057118658!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e39d9180f2a243%3A0xcb6c786189931c66!2sFollen%20Church!5e0!3m2!1sen!2sus!4v1766070401981!5m2!1sen!2sus" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </>
    )
}